import './UnregisteredUsersSummaryPane.scss';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import { ProjectRole } from '../../../../../../../../../__legacy__/models/userRole.model';
import { IImportAnnotationUnregisteredUser } from '../../../../models/ImportAnnotationsReport';

interface IProps {
  unregisteredUsers: IImportAnnotationUnregisteredUser[];
}

export const UnregisteredUsersSummaryPane = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const { unregisteredUsers } = props;
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const toggle = (): void => {
    setIsOpened(!isOpened);
  };

  const mapUserRoles = (roles: string[]): string => {
    let result = '';
    if (roles.length === 2) {
      result += `${ProjectRole.Annotator} ${t('and')} ${ProjectRole.Reviewer}`;
    } else if (roles.includes(ProjectRole.Annotator)) {
      result += ProjectRole.Annotator;
    } else if (roles.includes(ProjectRole.Reviewer)) {
      result += ProjectRole.Reviewer;
    }

    return result;
  };

  return (
    <>
      <p
        className='collapsible'
        onClick={toggle}
      >
        {unregisteredUsers.length} {t('new.projects.details.import_annotations.steps.summary.user', { count: unregisteredUsers.length })}
        <span className='fail'> {t('new.projects.details.import_annotations.steps.summary.not_found')}</span>{' '}
        <FontAwesomeIcon icon={isOpened ? faCaretUp : faCaretDown} />
      </p>
      {isOpened && (
        <div className='users-summary'>
          <ul>
            {unregisteredUsers.map((user) => (
              <li key={user.email}>
                {user.email} - {mapUserRoles(user.roles)}
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
});
